import { Component, OnInit } from "@angular/core";
import { BaseComponent, UserService, HelperService, WindowService, OrderService } from "@mypxplat/xplat/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AppService } from "@mypxplat/xplat/web/core";
import { EditAddressComponent } from "../../../modals";

@Component({
  selector: "myp-account-addresses",
  templateUrl: "./addresses.component.html",
  standalone: false,
})
export class AddressesComponent extends BaseComponent implements OnInit {
  public loading: boolean;
  public addresses: Array<any>;
  public editingAddresses: any = {};
  constructor(
    public userService: UserService,
    public helperService: HelperService,
    public appService: AppService,
    public orderService: OrderService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.loading = true;
    this.orderService.getFenderShopifyAccountDetails(this.userService.user.email, true).subscribe((result: any) => {
      this.loading = false;
      let defaultAddressId = this.orderService.fenderUserShopData?.defaultAddress?.id;
      this.addresses = this.orderService.fenderUserShopData?.addresses;
      if (this.addresses?.length && defaultAddressId) {
        this.addresses.forEach((address) => {
          if (address.id == defaultAddressId) address.default = true;
        });
      }
    });
  }

  editAddress(address: any) {
    const modalRef = this.appService.showModal(EditAddressComponent, { size: "sm" });
    let transformedAddress = {
      city: address.city,
      countryCode: address.countryCode,
      id: address.id,
      address_phone: address.phone,
      state: address.provinceCode,
      street: address.address1,
      street2: address.address2,
      zipcode: address.zip,
    };
    modalRef.componentInstance.address = transformedAddress;
    modalRef.componentInstance.fenderShopifyAddress = true;
    modalRef.componentInstance.addressAdded.subscribe((result) => {
      if (result) {
        console.log("save address", result);

        // find the ID in a string that looks like this: gid://shopify/MailingAddress/11046665912615?model_name=CustomerAddress
        this.editingAddresses[address.id] = true;
        let addressId = result.id.split("MailingAddress/")[1].split("?model_name=CustomerAddress")[0];
        this.orderService
          .addUpdateShopifyAddress(
            this.orderService.fenderUserShopData.shopifyId,
            {
              address1: result.street,
              address2: result.street2,
              city: result.city,
              company: "",
              provinceCode: result.state,
              countryCode: result.countryCode,
              firstName: this.userService.user.firstName,
              lastName: this.userService.user.lastName,
              phone: result.address_phone,
              zip: result.zipcode,
            },
            addressId
          )
          .subscribe((result) => {
            this.addresses = this.orderService.fenderUserShopData.addresses;
            this.addresses.forEach((address) => {
              let defaultAddressId = this.orderService.fenderUserShopData?.defaultAddress?.id;
              if (address.id == defaultAddressId) address.default = true;
            });
            this.editingAddresses[address.id] = false;
          });

        // heres where we actually save the address. coming soon.
      }
    });
  }

  addAddress() {
    const modalRef = this.appService.showModal(EditAddressComponent, { size: "sm" });
    modalRef.componentInstance.address = {};
    modalRef.componentInstance.fenderShopifyAddress = true;
    modalRef.componentInstance.addressAdded.subscribe((result) => {
      if (result) {
        this.orderService
          .addUpdateShopifyAddress(this.orderService.fenderUserShopData.shopifyId, {
            address1: result.street,
            address2: result.street2,
            city: result.city,
            company: "",
            provinceCode: result.state,
            countryCode: result.countryCode,
            firstName: this.userService.user.firstName,
            lastName: this.userService.user.lastName,
            phone: result.address_phone,
            zip: result.zipcode,
          })
          .subscribe((result) => {
            this.addresses = this.orderService.fenderUserShopData?.addresses;
            let defaultAddressId = this.orderService.fenderUserShopData?.defaultAddress?.id;
            if (this.addresses?.length && defaultAddressId) {
              this.addresses.forEach((address) => {
                if (address.id == defaultAddressId) address.default = true;
              });
            }
          });

        // heres where we actually save the address. coming soon.
      }
    });
  }

  deleteAddress(address: any) {
    this.appService.confirm("Are you sure you want to delete this address?").then((result) => {
      if (result) {
        this.orderService.deleteShopifyAddress(this.orderService.fenderUserShopData.shopifyId, address.id).subscribe({
          next: (result) => {
            this.addresses = this.orderService.fenderUserShopData?.addresses;
          },
          error: (error) => {
            this.appService.alert("There was an error deleting your address, please try again or contact support.");
          },
        });
      }
    });
  }
}
